import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcd40b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "tw-mt-2 tw-mb-4 tw-w-full tw-h-auto tw-flex tw-flex-col tw-gap-4 tw-p-3 tw-box-border tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-rounded-[8px] tw-bg-[#F8FBFD]" }
const _hoisted_5 = { class: "upload__section md:!tw-h-[100px]" }
const _hoisted_6 = { class: "uploade-wrapper custom-file-upload !tw-h-[97px] md:!tw-h-full !tw-w-full !tw-mt-4 !tw-rounded-lg !tw-mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "attachment-list !tw-mt-0"
}
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_9 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-pb-4" }
const _hoisted_10 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-1" }
const _hoisted_11 = {
  key: 0,
  class: "w-full sm:w-80 tw-py-4"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  Uploading photo...", -1))
const _hoisted_13 = { class: "modal-footer" }

import { ref, computed } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import PdfIcon from "@/core/components/icons/PdfIcon.vue";
import ImageIcon from "@/core/components/icons/ImageIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadTradePassportBannerModal',
  emits: ["on-close", "on-submit"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const emits = __emit;

const internalInstance = getCurrentInstance();
const formRef = ref<any>(null);
const isUploadImg = ref<boolean>(false);

const validation = ref({
  attachments: [(v: any[]) => v.length > 0 || "Photo is required"],
});

const offerDescription = ref<string>("");

const selectedDocuments = ref<any[]>([]);

const isFileUploading = ref(false);
const attachmentError = ref("");
const uploadProgress = ref(0);
const imageData = ref("");
const qualificationData = ref({
  certificateId: null,
  registrationNumber: null,
  url: null,
  attachments: [],
}) as any;

const user = computed(() => store.getters[`${USER_STORE}/user`]);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const onFileChange = async (event: any) => {
  try {
    isFileUploading.value = true;
    attachmentError.value = "";
    uploadProgress.value = 0;

    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const files = Array.from(fileInput.files);
      let progressInterval: any;

      // Add new files if they don't already exist
      files.forEach((file: any) => {
        if (!selectedDocuments.value.some((doc) => doc.name === file.name)) {
          selectedDocuments.value.push(file);
        }
      });

      // Ensure there's at least one file to upload before starting progress
      if (selectedDocuments.value.length) {
        console.log("Uploading started...");

        progressInterval = setInterval(() => {
          if (uploadProgress.value < 100) {
            uploadProgress.value += 10;
          } else {
            clearInterval(progressInterval);
          }
        }, 200);

        // Simulate async upload time
        await new Promise((resolve) => setTimeout(resolve, 2200));

        clearInterval(progressInterval);
        uploadProgress.value = 100;
      }

      event.target.value = "";
      console.log(selectedDocuments.value, "selectedDocuments.value");
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    attachmentError.value = "Error uploading file.";
  } finally {
    setTimeout(() => {
      isFileUploading.value = false;
    }, 500); // Delay hiding the loader to ensure UI updates properly
  }
};

// const onFileChange = async (event: any) => {
//   try {
//     isFileUploading.value = true;
//     attachmentError.value = "";
//     uploadProgress.value = 0;
//     const fileInput = event.target;
//     if (fileInput.files && fileInput.files.length > 0) {
//       const file = fileInput.files[0];

//       imageData.value = file;
//       const formData = new FormData();
//       formData.append("file", imageData.value);

//       const progressInterval = setInterval(() => {
//         if (uploadProgress.value < 100) {
//           uploadProgress.value += 10;
//         }
//       }, 120);

//       const uploadImg = await store.dispatch(
//         `${USER_STORE}/uploadProfileImage`,
//         formData
//       );
//       if (uploadImg) {
//         clearInterval(progressInterval);
//         uploadProgress.value = 100;
//       }

//       qualificationData.value.attachments = [uploadImg];

//       console.log(formData, "formData");
//       console.log(imageData.value, "imageData.value");
//       console.log(uploadImg, "uploadImg");
//       console.log(qualificationData.value, "qualificationData.value");
//     }
//   } catch (error) {
//     console.error("Error uploading file:", error);
//     attachmentError.value = "Error uploading file.";
//   } finally {
//     isFileUploading.value = false;
//   }
// };

// const onFileChange = (event: any) => {
//   const files = event.target.files;
//   if (files && files.length > 0) {
//     Array.from(files).forEach((file: any) => {
//       if (!selectedDocuments.value.some((doc) => doc.name === file.name)) {
//         selectedDocuments.value.push(file);
//       }
//     });
//   }

//   event.target.value = "";
// };

const onSubmit = async () => {
  const isFormValid = await formRef.value.validate();

  if (!isFormValid.valid) return;

  try {
    isUploadImg.value = true;
    // const attachments = [] as any;
    let payload = {} as any;
    for (const attachment of selectedDocuments.value) {
      const formData = new FormData();
      formData.append("file", attachment);
      const uploadImg = await store.dispatch(
        `${USER_STORE}/uploadProfileImage`,
        formData
      );

      if (uploadImg?.publicUrl) {
        // attachments.push(uploadImg.attachment);
        payload = {
          banner: uploadImg.attachment,
        };
      } else {
        displayToastMessage(
          internalInstance,
          "Failed to upload an attachment.",
          "error"
        );
      }
    }

    console.log(payload, "payload");

    const request = {
      userId: user.value?.id,
      workstationId: activeUserWorkstation.value?.id,
      payload,
    };

    console.log(request, "request");

    const response = await store.dispatch(
      `${USER_STORE}/updateTradepassportBanner`,
      request
    );

    store.dispatch(`${WORKSTATION}/setActiveUserWorkstation`);

    console.log(response, "response");

    // emits("on-submit", { userMessageContent, disputeOffer });
  } catch (error: any) {
    if (error.response) {
      if (error.response.status) {
        const errorMessage =
          error.response.data.message || "An error occurred. Please try again.";
        displayToastMessage(internalInstance, errorMessage, "error");
      } else {
        // Handle other status codes or errors
        displayToastMessage(
          internalInstance,
          `Error: ${error.response.statusText}`,
          "error"
        );
      }
    } else {
      displayToastMessage(
        internalInstance,
        "The request took too long and timed out. Please try again later.",
        "error"
      );
    }
  } finally {
    isUploadImg.value = false;
    selectedDocuments.value = [];
    offerDescription.value = "";
    onClickBackButton();
  }
};

const removeAttachment = (index: number) => {
  selectedDocuments.value.splice(index, 1);
};

const onClickBackButton = () => {
  return emits("on-close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "dispute-evidence-modal !tw-gap-0",
    onOnClose: onClickBackButton,
    maxWidth: "100%",
    width: "588px",
    borderRadius: "8px",
    isShowCloseButton: true,
    isShowHeader: true,
    isTitleStrong: false,
    headerTitle: "Add Banner",
    headerDescriptionTextSize: "h6",
    headerDescriptionLineHeight: "20px",
    gap: "0"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref_key: "formRef",
            ref: formRef,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
            rules: validation.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_file_input, {
                        class: _normalizeClass(["upload_file !tw-mb-0 !tw-bg-white", {
                        'added-img':
                          selectedDocuments.value && selectedDocuments.value?.length,
                      }]),
                        label: "Upload photo",
                        variant: "solo-filled",
                        modelValue: selectedDocuments.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedDocuments).value = $event)),
                        accept: ".jpg, .jpeg, .png",
                        onChange: onFileChange,
                        "prepend-icon": "mdi-file-image-box"
                      }, null, 8, ["modelValue", "class"])
                    ])
                  ]),
                  (!isFileUploading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDocuments.value, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "attachment-item !tw-bg-none !tw-p-0 !tw-border-none"
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              (file.type === 'application/pdf')
                                ? (_openBlock(), _createBlock(PdfIcon, {
                                    key: 0,
                                    class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                  }))
                                : (_openBlock(), _createBlock(ImageIcon, {
                                    key: 1,
                                    class: "!tw-w-[14px] !tw-h-[12px] !tw-min-w-[14px]"
                                  })),
                              _createVNode(Text, {
                                variant: "p",
                                textWeight: "400"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(file.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createVNode(_component_v_icon, {
                              class: "cursor-pointer !tw-text-[16px]",
                              icon: "mdi-close",
                              onClick: ($event: any) => (removeAttachment(index))
                            }, null, 8, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(Text, {
                      variant: "p",
                      textColor: "rgba(12, 15, 74, 0.5)",
                      textWeight: "500",
                      lineHeight: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Width: 854px X Height: 150px ")
                      ]),
                      _: 1
                    }),
                    _createVNode(Text, {
                      variant: "p",
                      textColor: "rgba(12, 15, 74, 0.5)",
                      textWeight: "500",
                      lineHeight: "18px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Supported Formats: JPG, PNG ")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(Text, {
                    variant: "p",
                    textColor: "rgba(12, 15, 74, 0.5)",
                    textWeight: "500",
                    lineHeight: "18px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Maximum File Size: 2MB ")
                    ]),
                    _: 1
                  })
                ]),
                (isFileUploading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_v_progress_linear, {
                        "model-value": uploadProgress.value,
                        height: 10,
                        width: 5,
                        striped: "",
                        rounded: "",
                        color: "#0C0F4A"
                      }, null, 8, ["model-value"]),
                      _createTextVNode(" " + _toDisplayString(uploadProgress.value) + " %", 1),
                      _hoisted_12
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_btn, {
                  class: "button button-purple-border",
                  onClick: onClickBackButton,
                  disabled: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  class: "button button-purple",
                  onClick: onSubmit,
                  loading: isUploadImg.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})